import React from 'react';
import {
  Home, HomeOutlined,
  MailOutlined,
  Person, PersonOutline,
  Settings, SettingsOutlined,
} from '@mui/icons-material';
import { SideBarNav } from '@uplift/types';
import { isRestricted } from '@uplift/utils';
import { l10nEnService } from '@uplift/services';
import { ROUTING_CONFIG } from '@uplift/constants';
import { useFeatureFlag, useL10n } from '@uplift/hooks';

import { useCurrentuser } from '@uplift/contexts';
import {
  Payments,
  PaymentsOutlined,
  HealthAndSafety,
  HealthAndSafetyOutlined,
} from '@uplift/icons';
import { CampusPlan } from '@uplift/api';
import { useCurrentStudentDetails } from '@uplift/queries';
import { useMessagingContext } from '@uplift/ui-v2';


const useMainNavConfig = (l10n: typeof l10nEnService): SideBarNav[] => {
  const me = useCurrentuser();
  const currentStudent = useCurrentStudentDetails({ suspense: true });
  const restricted = isRestricted(me);
  const IN_APP_MESSAGING = useFeatureFlag('IN_APP_MESSAGING');
  const messaging = useMessagingContext();

  return [
    {
      type: 'link' as const,
      name: l10n.pages.main,
      to: ROUTING_CONFIG.main,
      icon: <HomeOutlined />,
      activeIcon: <Home />,
      restricted: restricted,
    },
    {
      type: 'link' as const,
      name: l10n.payments.payments,
      to: ROUTING_CONFIG.payments,
      exact: false,
      icon: <PaymentsOutlined />,
      activeIcon: <Payments />,
      hidden: [ CampusPlan.flex, CampusPlan.complete ].includes(currentStudent?.higherEdOrg?.contract?.plan?.type)
    },
    {
      type: 'link' as const,
      name: l10n.payments.insurance,
      to: ROUTING_CONFIG.insurance,
      exact: true,
      icon: <HealthAndSafetyOutlined />,
      activeIcon: <HealthAndSafety />,
    },
    {
      type: 'button' as const,
      name: l10n.pages.messages,
      icon: <MailOutlined />,
      onClick: () => {
        messaging.openModal();
      },
      badgeContent: messaging.unreadMessagesCount,
      hidden: !IN_APP_MESSAGING,
    },
    {
      type: 'link' as const,
      name: l10n.pages.yourCareTeam,
      to: ROUTING_CONFIG.careTeam,
      icon: <PersonOutline />,
      activeIcon: <Person />,
      exact: false,
      restricted: restricted,
    },
    {
      type: 'link' as const,
      name: l10n.pages.accountSettings,
      to: ROUTING_CONFIG.settings,
      icon: <SettingsOutlined />,
      activeIcon: <Settings />,
      exact: false,
      restricted: restricted,
    },
  ].filter((el) => !el.hidden);
};

export const useLayoutConf = () => {
  const l10n = useL10n();
  const mainNavConfig = useMainNavConfig(l10n);

  return {
    mainNavConfig
  };
};
